<template>
  <div>
    <div class="mb_controller_home h-100" v-if="loads">
      <!-- hide dlu untuk interstitial nanti bukak balik -->
      <DesktopInterstitial v-if="desktop" />
      <MobileInterstitial v-if="mobile" />
      <mastheadCarousel class="mb-3 mb-5" />

      <div class="position-relative main-list-wrapper">
        <div class="main-list-section d-flex flex-column mb-5">
          <!-- hide first v1 -->
          <HomepageContinueWatching
            class="mt-5 mb-3"
            v-if="initializeContinueWatchingRails"
          />

          <!-- recommendation -->
          <HomepageRecommendation1
            class="my-2 my-md-4"
            v-if="initializeRecommendation"
          />
          <!-- <HomepageRecommendation2
            class="my-2 my-md-4"
            v-if="initializeRecommendation"
          />
          <HomepageRecommendation3
            class="my-2 my-md-4"
            v-if="initializeRecommendation"
          />
          <HomepageRecommendation4
            class="my-2 my-md-4"
            v-if="initializeRecommendation"
          /> -->

          <FavoriteRails v-if="initializeFavoriteRailes" class="my-2 my-md-4" />

          <TvFastChannelRailsV2 class="my-2 my-md-4" />
          <TvRailsV2 class="my-2 my-md-4" />
          <SaluranKhasV2 class="my-2 my-md-4" />

          <!-- ads top -->
          <billboardBannerTop v-if="desktop"></billboardBannerTop>
          <mrecBannerTop v-if="mobile"></mrecBannerTop>
          <!-- <SetulusKasihV2 class="my-2 my-md-4" /> -->
          <!-- <RancanganKhasHomepageRailsV2 class="my-2 my-md-4" /> -->
          <PopularRailsV2 class="my-2 my-md-4" />
          <EksklusifRailsV2 class="my-2 my-md-4" />
          <!-- akan datang dan betul2 baharu rails -->
          <AkanDatang class="my-3 my-md-4" />
          <BetulBetulBaharu class="my-3 my-md-4" />
          <DramaRailsV2 class="my-3 my-md-4" />
          <Telefilem class="my-3 my-md-2" />
          <!-- <BintangRTMRails class="my-4" /> -->
          <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
          <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>

          <!-- listing for rtmklik -->
          <!-- tv,popular,drama,telefilem,berita,hiburan -->
          <!-- hide first v1 -->
          <!-- <HomepageSaluranTV /> -->

          <!-- <MaintainanceDesktop />
          <MaintainanceMobile /> -->

          <!-- hide first v1 -->
          <!-- <PopularVOD />
          <CategoryRailsCustom /> -->
          <!-- <EkslusifRails /> -->
          <!-- <Drama /> -->

          <!-- ads mid -->
          <!-- ads -->

          <BeritaRailsV2 class="my-4" />
          <!-- <BesPlusRails class="my-2" /> -->
          <HiburanRailsV2 class="my-4" />

          <!-- hide first v1 -->
          <!-- <BeritaRails />
          <HiburanRails /> -->

          <!-- ads bottom -->
          <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
          <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
        </div>
      </div>
    </div>
    <div
      v-else
      style="min-height: 70vh; display: flex; align-items: center;justify-content: center;color: white;"
    >
      <p>loading</p>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import carousel from "vue-owl-carousel";
// ads
// import Popup from "../components/popup/googleAdsPopup.vue";
import billboardBannerTop from "../components/ads/homepage/billboardBannerTop";
import mrecBannerTop from "../components/ads/homepage/mrecBannerTop";
import billboardBannerMiddle from "../components/ads/homepage/billboardBannerMiddle";
import mrecBannerMiddle from "../components/ads/homepage/mrecBannerMiddle";
import BillboardBannerBottom from "../components/ads/homepage/billboardBannerBottom";
import MrecBannerBottom from "../components/ads/homepage/mrecBannerBottom";
// v2
import mastheadCarousel from "@/components/carousel/homepage/v2/homepageMainCarousel";
import TvRailsV2 from "../components/carousel/homepage/v2/tvRails.vue";
import TvFastChannelRailsV2 from "../components/carousel/homepage/v2/tvFastChannelRails.vue";
import SaluranKhasV2 from "../components/carousel/homepage/v2/saluranKhas.vue";
import BeritaRailsV2 from "../components/carousel/homepage/v2/beritaRails.vue";
import HiburanRailsV2 from "../components/carousel/homepage/v2/hiburanRails.vue";
import DramaRailsV2 from "../components/carousel/homepage/v2/dramaRails.vue";
import PopularRailsV2 from "../components/carousel/homepage/v2/popularVod.vue";
import FavoriteRails from "../components/carousel/homepage/v2/favoriteRails.vue";
import EksklusifRailsV2 from "../components/carousel/homepage/v2/eksklusifRails.vue";
import Telefilem from "../components/carousel/homepage/v2/telefilemRails.vue";
import BetulBetulBaharu from "../components/carousel/homepage/v2/betulBetulBaharuRails.vue";
import AkanDatang from "../components/carousel/homepage/v2/akanDatangRails.vue";
// import SetulusKasihV2 from "../components/carousel/homepage/v2/setulusKasih.vue";
// import BesPlusRails from "../components/carousel/homepage/v2/besPlusRails.vue";
// rtmklik
// import HomepageSaluranTV from "../components/carousel/homepage/saluranTV.vue";
// import PopularVOD from "../components/carousel/homepage/popularVod.vue";
// import Drama from "../components/carousel/homepage/dramaRails.vue";
// import BeritaRails from "../components/carousel/homepage/beritaRails.vue";
// import HiburanRails from "../components/carousel/homepage/hiburanRails.vue";
import HomepageContinueWatching from "../components/carousel/homepageContinueWatching.vue";

// import CategoryRailsCustom from "../components/carousel/homepage/categoryRailsCustom.vue";
import DesktopInterstitial from "../components/ads/interstitial/desktopInterstitial.vue";
import MobileInterstitial from "../components/ads/interstitial/mobileInterstitial.vue";

// Recommendation
import HomepageRecommendation1 from "../components/carousel/homepage/v2/recommendation/pilihanRancanganUntukAnda.vue";
import HomepageRecommendation2 from "../components/carousel/homepage/v2/recommendation/recommendation2.vue";
import HomepageRecommendation3 from "../components/carousel/homepage/v2/recommendation/recommendation3.vue";
import HomepageRecommendation4 from "../components/carousel/homepage/v2/recommendation/recommendation4.vue";

// maintainance
// import MaintainanceDesktop from "../components/ads/maintainance/leaderboardTop.vue";
// import MaintainanceMobile from "../components/ads/maintainance/mobileMidRec.vue";

export default {
  data: function() {
    return {
      tablet: false,
      mobile: false,
      desktop: false,
      initializeContinueWatchingRails: false,
      initializeRecommendation: false,
      initializeFavoriteRailes: false,
      loads: false,
      path: "",
      size: [],
      id: "",
      favorite: false,
    };
  },
  components: {
    mastheadCarousel: mastheadCarousel,
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom: BillboardBannerBottom,
    mrecbannerbottom: MrecBannerBottom,
    // HomepageSaluranTV,
    // PopularVOD,
    // Drama,
    Telefilem,
    // BeritaRails,
    // HiburanRails,
    // MaintainanceDesktop,
    // MaintainanceMobile,
    HomepageContinueWatching,
    // CategoryRailsCustom,
    // Popup,
    DesktopInterstitial,
    MobileInterstitial,
    TvRailsV2,
    TvFastChannelRailsV2,
    SaluranKhasV2,
    BeritaRailsV2,
    HiburanRailsV2,
    DramaRailsV2,
    PopularRailsV2,
    FavoriteRails,
    EksklusifRailsV2,
    // BintangRTMRails,
    // RancanganKhasHomepageRailsV2,
    // SetulusKasihV2,
    BetulBetulBaharu,
    AkanDatang,
    HomepageRecommendation1,
    HomepageRecommendation2,
    HomepageRecommendation3,
    HomepageRecommendation4,
  },
  methods: {
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "home",
          site: "RTMKlik",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
  },
  created: function() {},
  mounted() {
    const token = localStorage.getItem("token");
    const showFavorite = localStorage.getItem("setFavorite");
    if (token) {
      this.initializeContinueWatchingRails = true;
      this.initializeRecommendation = true;
    }

    if (token && showFavorite) {
      this.initializeFavoriteRailes = true;
    }

    this.deviceCheck();
    setTimeout(
      function() {
        this.initializepageview();
      }.bind(this),
      200
    );

    setTimeout(
      function() {
        this.loads = !this.loads;
      }.bind(this),
      1000
    );
  },
  beforeMount() {
    var vm = this;
    vm.path = "/22777916944/RTMKlik_Web_Interstitial_Banner_640x480";
    vm.size = [640, 480];
    vm.id = "div-gpt-ad-1690964945987-0";
  },
};
</script>

<style scoped>
.bg {
  background: #111319;
}
</style>

<style>
.pre-formatted {
  white-space: pre;
}
</style>
